// extracted by mini-css-extract-plugin
export default {"button":"V5H4n6IeSuFnCsFMpMDv","primary":"QvhDJTwKahmdFNFmkGWy","fullWidth":"WaWVy1clo_d43qKRML1d"};